import React, { useState, useEffect } from 'react';

interface ImageWithDimensionsProps {
  src: string;
  alt: string;
  className?: string;
}

const ImageWithDimensions: React.FC<ImageWithDimensionsProps> = ({ 
  src, 
  alt,
  className = "" 
}) => {
  const [dimensions, setDimensions] = useState<{ width: number; height: number } | null>(null);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setDimensions({
        width: img.naturalWidth,
        height: img.naturalHeight
      });
    };
  }, [src]);

  return (
    <div className="relative h-full">
      <img
        src={src}
        alt={alt}
        className={className}
      />
      {dimensions && (
        <div className="absolute bottom-2 right-2 px-2 py-1 bg-background/80 backdrop-blur-sm rounded text-xs text-foreground/80">
          {dimensions.width} × {dimensions.height}
        </div>
      )}
    </div>
  );
};

export default ImageWithDimensions;